/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils
import { hoverTransition } from '../../utils/styles/general';



/* ++++++++++ --------------- EXPANDABLE SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  expandablesection: {
    maxWidth: pxToEm(1280),
    background: '#fff',
    boxShadow: replacePXinStringWithEM('0px 0px 24px rgba(172, 217, 251, 0.2)'),
    border: replacePXinStringWithEM(`1px solid ${themeV2.color.base.gray.button}`),
    borderRadius: pxToEm(12),
    textAlign: 'left',
    marginBottom: pxToEm(16),
    extend: hoverTransition(),
    '&:hover': {
        boxShadow: replacePXinStringWithEM('0px 0px 24px 0px rgba(172, 217, 251, 0.5)')
    },
    '& h2': {
      fontWeight: 700,
      fontSize: pxToEm(16),
      lineHeight: pxToEm(24),
      minWidth: pxToEm(150)
    },
    '& h5,h6': {
      whiteSpace: 'nowrap'
    },
    '& h4,h5,h6': {
      fontSize: pxToEm(14),
      lineHeight: pxToEm(22),
    },
    '& h4': {
      fontWeight: 400,
      lineHeight: pxToEm(22)
    },
    '& h5': {
      fontWeight: 500
    },
    '& h6': {
      fontWeight: 400
    },
    '& .innerWrap': {
      boxSizing: 'content-box',
      backgroundColor: themeV2.color.background.light.gray,
      borderRadius: pxToEm(4),
      margin: replacePXinStringWithEM('0 8px'),
      padding: pxToEm(16),
      '& .sectioncard:last-child': {
        marginBottom: '0'
      }
    },
    '& > .collapsable': {
      overflow: 'hidden',
      maxHeight: '0px',
      transition: 'max-height 0.3s'
    },
    '& .collapsable.opened': {
      maxHeight: '100%',
      overflow: 'unset' // needed for sticky elements within to function properly
    },
    '& > .footer': {
      minHeight: pxToEm(80),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: replacePXinStringWithEM('0 24px'),
      [mediaQuery.customizeThinnest]: {
        justifyContent: 'center'
      }
    },
    '& .name-controls': {
      display: 'flex',
      flexWrap: 'wrap',
      '& .control': {
        width: pxToEm(172),
        marginTop: pxToEm(16)
      }
    },
    '& > .controls': {
      '& .button:not(:first-child)': {
        marginLeft: pxToEm(16)
      },
      '& .button': {
        height: pxToEm(32),
        width: 'auto',
        padding: replacePXinStringWithEM('0 16px'),
        '& .text': {
          fontSize: pxToEm(14),
          fontWeight: 500,
          fontFamily: '"Work Sans", sans-serif;'
        }
      }
    },
    '& .formelement': {
    },
    '& .custom-control': {
      '& .control': {
        width: pxToEm(62),
        marginTop: pxToEm(16)
      }
    },
    '&.expandablesectionv2': {
      '& .footer': {
        display: 'none',
        borderTop: '2px solid #aeb6d6',
        margin: replacePXinStringWithEM('0 24px')
      },
      '& .controls .button': {
        height: `${pxToEm(40)} !important`
      },
      '& .innerWrap': {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToEm(48),
        backgroundColor: themeV2.color.base.white,
        padding: replacePXinStringWithEM('16px 32px'),
        '& label': {
          fontWeight: `400 !important`
        }
      }
    }
  }
});

